<template>
  <div>
    <a-modal
      v-model="visibleModalPassword"
      :title="$t('profil.changerPrametreTeacher')"
      width="60%"
      :ok-button-props="{
        props: { disabled: hasErrors(form.getFieldsError()) },
      }"
      @cancel="handleCancel"
      v-if="!fetchToken"
    >
      <a-alert
        type="warning"
        show-icon
        class="mb-4"
        :message="$t('profil.teacherCredentialsSessionWarning')"
      />
      <div class="row" v-if="token && token != ''">
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <p class="text-dark">{{ $t("enseignant.usernameEmail") }}</p>
              <a-form
                layout="inline"
                :form="form"
                @submit="handleUserNameChange"
                class="login-form"
                style="width: 100%"
              >
                <a-form-item
                  :validate-status="userNameError() ? 'error' : ''"
                  :help="userNameError() || ''"
                  style="width: 100%"
                >
                  <a-input
                    style="width: 100%"
                    v-decorator="[
                      'email',
                      {
                        initialValue: credentials.email,
                        rules: [
                          {
                            required: true,
                            message: $t('requis.email'),
                          },
                          {
                            validator: validateNoWhitespace,
                            message: $t('requis.noWhitespace'),
                          },
                        ],
                      },
                    ]"
                    :placeholder="$t('enseignant.usernameEmail')"
                  >
                    <a-icon
                      slot="prefix"
                      type="user"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input>
                </a-form-item>
                <a-button
                  type="primary"
                  class="mt-4"
                  @click="handleUserNameChange"
                  :loading="loading"
                  :disabled="loading"
                  >{{ $t("action.enregistrer") }}</a-button
                >
              </a-form>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div
            :class="
              status == 'inactive'
                ? 'card border-danger mb-3'
                : 'card border-success mb-3'
            "
          >
            <div class="card-header text-dark">
              {{ $t("enseignant.deactivateOrActivateTeacherAccount") }}
            </div>
            <div class="card-body">
              <p class="card-text">
                <a-tag
                  :color="status == 'inactive' ? 'red' : 'green'"
                  class="text-wrap"
                >
                  {{
                    status == "active"
                      ? $t("studentCredentials.accountActivated")
                      : $t("studentCredentials.accountDeactivated")
                  }}
                </a-tag>
              </p>

              <a-button
                type="primary"
                @click="changeStatus"
                :loading="statusBtnLoading"
                :disabled="statusBtnLoading"
                >{{ status == "active" ? $t("studentCredentials.deactivate") : $t("studentCredentials.activate") }}</a-button
              >
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <p class="text-dark">
                {{ $t("profil.resetPwd") }}
              </p>
              <a-form
                layout="inline"
                :form="passwordForm"
                @submit="handlePasswordChange"
                class="login-form"
                style="width: 100%"
              >
                <a-form-item
                  :validate-status="passwordError() ? 'error' : ''"
                  :help="passwordError() || ''"
                  style="width: 100%"
                >
                  <a-input-password
                    v-decorator="[
                      'password',
                      {
                        rules: [
                          {
                            validator: validateStrongPassword,
                          },
                        ],
                      },
                    ]"
                    :placeholder="$t('profil.NewPwd')"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input-password>
                </a-form-item>
                <a-form-item
                  :validate-status="passworConfirmdError() ? 'error' : ''"
                  :help="passworConfirmdError() || ''"
                  style="width: 100%"
                >
                  <a-input-password
                    v-decorator="[
                      'confirmPassword',
                      {
                        rules: [
                          {
                            validator: validatePass2,
                            message: $t('requis.confirmation'),
                          },
                        ],
                      },
                    ]"
                    :placeholder="$t('profil.ConfirmNewPwd')"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input-password>
                </a-form-item>
                <a-button
                  type="primary"
                  class="mt-2"
                  @click="handlePasswordChange"
                  :loading="loading"
                  :disabled="loading"
                  >{{ $t("action.enregistrer") }}</a-button
                >
              </a-form>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div
            :class="
              mfaEnabled
                ? 'card border-warning mb-3'
                : 'card border-secondary mb-3'
            "
          >
            <div class="card-header text-dark">
              {{ $t("mfa.twoFactorAuth") }}
            </div>
            <div class="card-body">
              <p class="card-text">
                <a-tag :color="mfaEnabled ? 'orange' : 'gold'">
                  {{
                    mfaEnabled
                      ? $t("mfa.adminStatusOn")
                      : $t("mfa.adminStatusOff")
                  }}
                </a-tag>
              </p>
              <p v-if="mfaEnabled" class="text-muted mb-3">
                {{ $t("mfa.method") }}:
                {{
                  mfaMethod === "sms"
                    ? $t("mfa.sms")
                    : $t("mfa.authenticatorApp")
                }}
              </p>
              <a-popconfirm
                v-if="mfaEnabled"
                :title="$t('mfa.adminDisableConfirm')"
                :ok-text="$t('mfa.disable')"
                :cancel-text="$t('action.annuler')"
                @confirm="disableMfa"
              >
                <a-button
                  type="danger"
                  :loading="mfaDisabling"
                  :disabled="mfaDisabling || loading"
                >
                  {{ $t("mfa.disable") }}
                </a-button>
              </a-popconfirm>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <p class="text-dark">{{ $t("enseignant.teacherQrCode") }}</p>
              <vue-qr
                :text="qrData"
                :logoSrc="getBuilding.logo"
                :callback="getQrImage"
                qid="teacher"
              ></vue-qr>
              <a-button type="primary" class="mt-2" @click="ImprimerQr"
                >{{ $t("action.imprimer") }}</a-button
              >
            </div>
          </div>
        </div>
      </div>
      <div v-else class="preview-placeholder">
        <div class="preview-empty" v-if="credentials && credentials.email">
          <a-icon type="user" class="preview-icon" style="font-size: 48px" />
          <p class="preview-text">
            {{ $t("profil.noTeacherCredentials") }}
          </p>
          <a-button
            type="success"
            @click="
              (e) => {
                e.preventDefault();
                addTeacherCredentials();
              }
            "
            :loading="addTeacherCredentialsLoading"
          >
            <a-icon type="user" />
            {{ $t("profil.ajouterCompteEnseignant") }}
          </a-button>
        </div>
        <div class="preview-empty" v-else>
          <a-icon
            type="warning"
            class="preview-icon"
            style="font-size: 48px; color: #d9d9d9"
          />
          <p class="preview-text">
            {{ $t("profil.noTeacherInfo") }}
          </p>
          <a-form layout="inline" :form="addEmailForm">
            <a-form-item
              :validate-status="emailError() ? 'error' : ''"
              :help="emailError() || ''"
              style="width: 100%"
            >
              <a-input
                :placeholder="$t('enseignant.usernameEmail')"
                v-decorator="[
                  'email',
                  {
                    rules: [
                      {
                        message: $t('requis.usernameEmail'),
                        required: true,
                      },
                      {
                        validator: validateNoWhitespace,
                        message: $t('requis.noWhitespace'),
                      },
                      {
                        validator: validateUsernameAvailable,
                        message: $t('error.usernameExists'),
                      },
                    ],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="email"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-item>
            <a-button
              type="primary"
              class="mt-4"
              @click="addEmail"
              :loading="loading"
              >{{ $t("action.ajouter") }}</a-button
            >
          </a-form>
        </div>
      </div>
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          {{ $t("action.retour") }}
        </a-button>
      </template>
    </a-modal>
    <a-skeleton v-else active :paragraph="{ rows: 10 }" />
  </div>
</template>
<script>
/* eslint-disable */

import apiClient from "@/services/axios";
import { mapState } from "vuex";
import VueQr from "vue-qr";
import "./updatePassword.css";
const { generateLoginPdf } = require("@/utilities/pdfLogin");
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}
export default {
  computed: {
    ...mapState(["settings"]),
    getBuilding() {
      return (
        this.settings.image.filter(
          (img) => img.db == this.settings.activeBuilding
        )[0] || {}
      );
    },
    qrData() {
      return window.btoa(this.token + "#" + this.settings.base_url);
    },
    mfaEnabled() {
      return !!this.mfa?.enabled;
    },
    mfaMethod() {
      return this.mfa?.method || "app";
    },
  },
  components: {
    VueQr,
  },
  props: [
    "idTeacher",
    "credentials",
    "visibleModalPassword",
    "firstName",
    "lastName",
    "status",
    "token",
    "fetchToken",
    "mfa",
  ],
  data() {
    return {
      formPassword: this.$form.createForm(this),
      loadingUtilisateur: false,
      qrDataImage: "",
      hasErrors,
      statusBtnLoading: false,
      form: this.$form.createForm(this, { name: "teacher_login" }),
      passwordForm: this.$form.createForm(this, { name: "teacher_passwords" }),
      loading: false,
      addTeacherCredentialsLoading: false,
      addEmailForm: this.$form.createForm(this, { name: "add_email" }),
      mfaDisabling: false,
    };
  },
  methods: {
    async validateUsernameAvailable(rule, value, callback) {
      try {
        await apiClient.post(`/teachers/checkUsernameAvailable`, {
          email: value,
        });
        callback(); // Username is available, no error
      } catch (error) {
        callback(new Error(this.$t("error.usernameExists"))); // Username is not available
      }
    },
    emailError() {
      const { getFieldError, isFieldTouched } = this.addEmailForm;
      return getFieldError("email");
    },
    addEmail(e) {
      e.preventDefault();
      this.addEmailForm.validateFields((err, values) => {
        if (err) {
          console.error(err);
        } else {
          this.addTeacherCredentials(values.email);
        }
      });
    },
    addTeacherCredentials(createdEmail) {
      this.addTeacherCredentialsLoading = true;
      apiClient
        .post("/teachers/addcredentials/" + this.idTeacher, {
          email: createdEmail || this.credentials.email,
        })
        .then(({ data }) => {
          const { email, token } = data;
          this.$emit("updateCredentials", {
            idTeacher: this.idTeacher,
            email: email,
          });
          this.$emit("updateToken", token);
          this.$message.success(this.$t("success.utilisateurMSA"));
        })
        .catch((error) => {
          this.$message.error(this.$t("error.modif"));
        })
        .finally(() => {
          this.addTeacherCredentialsLoading = false;
        });
    },
    validateNoWhitespace(rule, value, callback) {
      if (/\s/.test(value)) {
        callback(new Error(this.$t("studentCredentials.usernameNoWhitespace")));
      } else {
        callback();
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    getQrImage(dataUrl) {
      this.qrDataImage = dataUrl;
    },
    updatePassword(e) {
      this.loadingUtilisateur = true;
      e.preventDefault();
      this.formPassword.validateFieldsAndScroll((_err, values) => {
        if (values.password != values.confirmPassword) {
          this.$message.error(this.$t("error.verifier"));
          this.loadingUtilisateur = false;
        } else {
          apiClient
            .patch("/teachers/changecredentials/" + this.idTeacher, {
              email: values.email,
              password: values.password,
            })
            .then(() => {
              this.$message.success(this.$t("success.utilisateurMSA"));
              this.$emit("updateCredentials", {
                idTeacher: this.idTeacher,
                email: values.email,
              });
              this.$emit("cancel");
            })
            .catch((error) => {
              if (error.response && error.response.status === 422) {
                this.$message.error(this.$t("error.usernameExists"));
              } else {
                this.$message.error(this.$t("error.modif"));
              }
            });
          this.loadingUtilisateur = false;
        }
      });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    generatePdf(cred, withPwd = false) {
      this.$gtag.event("Imp information Edteacher", {
        event_category: "Impression PDF",
        event_label: "Personnel - ListeEnseignants section",
        value: 1,
      });

      generateLoginPdf({
        userName: cred.email,
        password: cred.password || "",
        withPwd: !!cred.password,
        settings: this.settings,
        qrDataImage: this.qrDataImage,
        userType: "teacher",
        t: this.$t.bind(this),
        locale: this.$i18n.locale,
      });
    },
    userNameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return getFieldError("email");
    },
    // Only show error after a field is touched.
    passwordError() {
      const { getFieldError, isFieldTouched } = this.passwordForm;
      return getFieldError("password");
    },
    passworConfirmdError() {
      const { getFieldError, isFieldTouched } = this.passwordForm;
      return getFieldError("confirmPassword");
    },
    validateStrongPassword(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("requis.mdp")));
      } else if (value == this.credentials.email) {
        callback(new Error(this.$t("profil.passwordMustNotMatchUsername")));
      } else if (value.length < 8) {
        callback(new Error(this.$t("profil.passwordMinLength")));
      } else if (!/[A-Z]/.test(value)) {
        callback(new Error(this.$t("profil.passwordMustIncludeUppercase")));
      } else if (!/[a-z]/.test(value)) {
        callback(new Error(this.$t("profil.passwordMustIncludeLowercase")));
      } else if (!/[0-9]/.test(value)) {
        callback(new Error(this.$t("profil.passwordMustIncludeDigit")));
      } else {
        callback();
      }
    },
    validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$t("studentCredentials.passwordConfirmationRequired")));
      } else if (value !== this.passwordForm.getFieldValue("password")) {
        callback(new Error(this.$t("studentCredentials.passwordMismatch")));
      } else {
        callback();
      }
    },
    handleCancel() {
      this.form.resetFields();
      this.passwordForm.resetFields();
      this.$emit("cancel");
    },
    ImprimerQr() {
      this.generatePdf({ email: this.credentials.email }, false);
    },
    changeStatus() {
      this.statusBtnLoading = true;

      let newStatus = this.status == "active" ? "inactive" : "active";
      apiClient
        .patch("/teachers/" + this.idTeacher, { data: { status: newStatus } })
        .then(() => {
          this.$message.success(this.$t("success.utilisateurMSA"));
          this.$emit("status-changed", newStatus);
          this.$emit("reload");
        })
        .catch((e) => {
          this.$message.error(this.$t("changementNonEffectue"));
        })
        .finally(() => {
          this.statusBtnLoading = false;
        });
    },
    disableMfa() {
      this.mfaDisabling = true;
      apiClient
        .patch("/teachers/mfa/disable/" + this.idTeacher)
        .then(() => {
          this.$message.success(this.$t("mfa.adminDisableSuccess"));
          this.$emit("mfa-disabled");
        })
        .catch(() => {
          this.$message.error(this.$t("mfa.adminDisableError"));
        })
        .finally(() => {
          this.mfaDisabling = false;
        });
    },
    handleUserNameChange(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (err) console.log(err);
        else {
          this.loading = true;
          apiClient
            .patch("/teachers/changecredentials/" + this.idTeacher, values)
            .then(async () => {
              this.credentials.email = values.email;
              this.$message.success(this.$t("success.enseignantMSA"));
              this.generatePdf(values);
              this.$emit("reload");
            })
            .catch((e) => {
              this.$message.error(e.response.data.error.message);
            })
            .finally(() => {
              this.loading = false;
              this.form.resetFields();
              this.$emit("cancel");
            });
        }
      });
    },
    handlePasswordChange(e) {
      e.preventDefault();
      this.passwordForm.validateFields((err, values) => {
        if (err) {
          console.log(err);
        } else {
          this.loading = true;
          let data = {
            email: this.credentials.email,
            password: values.password,
          };
          apiClient
            .patch("/teachers/changecredentials/" + this.idTeacher, data)
            .then(async () => {
              this.$message.success(this.$t("success.enseignantMSA"));
              this.generatePdf(data, true);
              this.$emit("reload");
            })
            .catch((e) => {
              this.$message.error(e.response.data.error.message);
            })
            .finally(() => {
              this.loading = false;
              this.passwordForm.resetFields();
              this.$emit("cancel");
            });
        }
      });
    },
  },
};
</script>
